module.exports = __webpack_public_path__ + "img/home-v2-community-right.b2a0c29.webp";